module.exports = __webpack_public_path__ + "img/google.3d2e9727.png";